export default "__VITE_ASSET__Ca0MOe6Y__"